export default {"src":"/_next/static/media/forgotPasswordIllustration.e20ddaed.svg","height":768,"width":733};